import { render } from "./stress-rating.vue?vue&type=template&id=2c2f2227&scoped=true"
import script from "./stress-rating.vue?vue&type=script&lang=js"
export * from "./stress-rating.vue?vue&type=script&lang=js"

import "./stress-rating.vue?vue&type=style&index=0&id=2c2f2227&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2f2227"]])

export default __exports__